import { Heart, CheckCircle2, MessageSquare } from 'lucide-react';
import { GALLERY_FAVORITES, GALLERY_SELECTIONS, GALLERY_COMMENTS } from '@/constants/testIds';
import { LightboxDownloadButton } from './LightboxDownloadButton';

const pillClass = (active) =>
  `inline-flex items-center gap-2 h-10 px-3.5 rounded-full text-xs uppercase tracking-[0.1em] transition-colors ${
    active ? 'text-[hsl(var(--lxra-gold))]' : 'text-[hsl(var(--lxra-fg))] hover:text-[hsl(var(--lxra-gold))]'
  }`;

/** Floating action pill under the lightbox photo (favorite / select / notes / download). */
export const LightboxActionBar = ({
  image, isFavorite, isSelected, limitReached, selectionLimit, commentCount, notesOpen,
  onToggleFavorite, onToggleSelection, onToggleNotes, onDownload,
}) => (
  <div className="flex items-center gap-2 rounded-full bg-black/70 backdrop-blur px-2 py-1.5 border border-[hsl(var(--lxra-border))]">
    {onToggleFavorite && (
      <button
        type="button"
        onClick={() => onToggleFavorite(image)}
        aria-pressed={isFavorite}
        aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
        data-testid={GALLERY_FAVORITES.lightboxHeart}
        className={pillClass(isFavorite)}
      >
        <Heart className={`h-4 w-4 ${isFavorite ? 'fill-current' : ''}`} />
        {isFavorite ? 'Favorited' : 'Favorite'}
      </button>
    )}
    {onToggleSelection && (
      <button
        type="button"
        onClick={() => { if (!limitReached) onToggleSelection(image); }}
        disabled={limitReached}
        aria-pressed={isSelected}
        aria-label={isSelected ? 'Remove from final picks' : 'Add to final picks'}
        data-testid={GALLERY_SELECTIONS.lightboxButton}
        title={limitReached ? `You've reached your limit of ${selectionLimit} picks` : undefined}
        className={`${pillClass(isSelected)} disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <CheckCircle2 className={`h-4 w-4 ${isSelected ? 'fill-current' : ''}`} />
        {isSelected ? 'Selected' : 'Select'}
      </button>
    )}
    {onToggleNotes && (
      <button
        type="button"
        onClick={onToggleNotes}
        aria-expanded={notesOpen}
        aria-label="Notes and comments"
        data-testid={GALLERY_COMMENTS.lightboxToggle}
        className={`${pillClass(notesOpen)} relative`}
      >
        <MessageSquare className="h-4 w-4" />
        Notes
        {commentCount > 0 && (
          <span className="absolute -top-1 -right-1 h-4 w-4 rounded-full bg-[hsl(var(--lxra-gold))] text-[#0A0A0A] text-[10px] font-semibold flex items-center justify-center">
            {commentCount}
          </span>
        )}
      </button>
    )}
    {onDownload && <LightboxDownloadButton image={image} onDownload={onDownload} />}
  </div>
);
